module.exports = __webpack_public_path__ + "static/media/icon_faq.33691773.svg";